import React, { useState } from 'react';
import QuestionerModal from '../components/QuestionerModal';
import '../styles/Questioner.css';

const QuestionerPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);

  return (
    <div className="questioner-page">
      {isModalOpen && <QuestionerModal closeModal={() => setIsModalOpen(false)} />}
    </div>
  );
};

export default QuestionerPage;
